import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'

import UnitTopicCatalog from 'src/pages/UnitTopicCatalog/UnitTopicCatalog'
import UnitTopicCatalogPlaceholder from 'src/pages/UnitTopicCatalog/UnitTopicCatalogPlaceholder'
import DataFetchError from 'src/ui/DataFetchError/DataFetchError'
import { t } from 'src/lib/i18n-react'

export const TOPIC_LIST = gql`
  query TOPIC_LIST($l1Code: LanguageEnum!, $l2Code: LanguageEnum!) {
    curriculum(native: $l1Code, learning: $l2Code) {
      levels(queueableOnly: true) {
        nodes {
          id
          name
          coverImageUrl
          countOfUnits
          progress {
            countOfQueuedUnits
          }
        }
      }
    }
  }
`

const UnitCatalogLazy = (props) => {
  const { l1Code, l2Code } = props

  const response = useQuery(TOPIC_LIST, {
    variables: {
      l1Code,
      l2Code,
    },
    fetchPolicy: 'network-only',
  })

  const { data, loading } = response
  const topics = data?.curriculum?.levels?.nodes

  if (loading) {
    return <UnitTopicCatalogPlaceholder />
  }

  if (topics) {
    return <UnitTopicCatalog title={t('Topics')} topics={topics} />
  }

  return <DataFetchError graphQLResponse={response} />
}

UnitCatalogLazy.propTypes = {
  l1Code: PropTypes.string.isRequired,
  l2Code: PropTypes.string.isRequired,
}

export default UnitCatalogLazy
